<template>
  <van-dialog
    v-model="isShowItms"
    :showConfirmButton="false"
    :showCancelButton="false"
    className="dialog-box"
  >
    <template #title> <div class="header">Disassemble</div> </template>
    <!-- <img src="https://img01.yzcdn.cn/vant/apple-3.jpg" /> -->
    <div class="content">
      <div class="main">
        <slot name="main"></slot>
      </div>
      <div class="footer">
        <div class="bot-left" @click="hide">No</div>
        <div class="bot-right" @click="submit">Yes</div>
      </div>
    </div>
  </van-dialog>
</template>
<script>
export default {
  props: {
    isShow: {
      type: Boolean,
    },
  },
  data() {
    return {
      isShowItms: this.isShow,
    };
  },
  watch: {
    isShow() {
      this.isShowItms = this.isShow;
    },
  },
  methods: {
    hide(){
        this.$emit('hide')
    },
    submit(){
      this.$emit('submit')    }
  },
};
</script>
<style lang="scss" scoped>
.dialog-box {
  padding: 3%;
}
.header {
  font-size: 0.56rem;
}
.content {
  width: 100%;
  height: 100%;
  background: white;
}
.main {
  width: 100%;
  margin: 10% 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.footer {
  width: 100%;
  display: flex;
  justify-content: space-around;
  .bot-left {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 2.92rem;
    height: 1rem;
    border-radius: 25px;
    border: 1px solid #ae6bf7;
  }
  .bot-right {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 2.92rem;
    height: 1rem;
    border-radius: 25px;
    border: 1px solid #ae6bf7;
    background: #ae6bf7;
  }
}
</style>
